'use client';

import React from 'react';
import { Box, Switch, useTheme } from '@mui/material';
import { DarkMode as DarkModeIcon, LightMode as LightModeIcon } from '@mui/icons-material';
import { alpha } from '@mui/material/styles';
import { useThemeMode } from '@/contexts/ThemeModeContext';

/** Sun / moon icon framing for the app bar (primary background). */
export const ThemeModeToggle: React.FC = () => {
  const theme = useTheme();
  const { mode, setMode } = useThemeMode();
  const isDark = mode === 'dark';
  const contrast = theme.palette.primary.contrastText;
  const dim = alpha(contrast, 0.55);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.25,
        mr: 1,
      }}
      aria-label={isDark ? 'Dark theme on' : 'Light theme on'}
    >
      <LightModeIcon
        sx={{
          fontSize: 20,
          color: isDark ? dim : contrast,
          opacity: isDark ? 0.85 : 1,
        }}
      />
      <Switch
        size="small"
        checked={isDark}
        onChange={(_, checked) => setMode(checked ? 'dark' : 'light')}
        slotProps={{ input: { 'aria-label': 'Toggle dark mode' } }}
        sx={{
          '& .MuiSwitch-switchBase': {
            color: contrast,
            '&.Mui-checked': { color: contrast },
            '& + .MuiSwitch-track': {
              backgroundColor: alpha(contrast, 0.35),
              opacity: 1,
            },
            '&.Mui-checked + .MuiSwitch-track': {
              backgroundColor: alpha(contrast, 0.45),
              opacity: 1,
            },
          },
        }}
      />
      <DarkModeIcon
        sx={{
          fontSize: 20,
          color: isDark ? contrast : dim,
          opacity: isDark ? 1 : 0.85,
        }}
      />
    </Box>
  );
};
